import {Action, Dispatch, Middleware, MiddlewareAPI} from 'redux';
import {AppState} from '../store';
import EventSource, {EventSourceInitDict} from 'eventsource';
import {
  ADD_EVENT_SOURCE,
  EventSourceActionTypes,
  REMOVE_EVENT_SOURCE,
} from '../../types/actions/EventSource.actions';
import {LOG_OUT, LogOut} from '../../types/actions/Auth.actions';
import {getAuthToken} from '../selectors/Auth';

const eventsource: {[url: string]: EventSource} = {};

export const createEventSourceMiddleware = (): Middleware => ({
  getState,
}: MiddlewareAPI<Dispatch, AppState>) => (next: Dispatch) => (
  action: EventSourceActionTypes | LogOut,
): Action | void => {
  if (action.type !== ADD_EVENT_SOURCE && action.type !== REMOVE_EVENT_SOURCE) {
    if (action.type === LOG_OUT) {
      Object.keys(eventsource).forEach((key) => {
        eventsource[key].close();
        delete eventsource[key];
      });
    }
    return next(action);
  }

  if (action.type === ADD_EVENT_SOURCE) {
    const {url, onMessage, onError, onOpen} = action.payload;
    if (eventsource[url]) {
      return;
    }
    const eventSourceInitDict: EventSourceInitDict = {
      headers: {
        Authorization: 'Bearer ' + getAuthToken(getState()),
      },
    };
    eventsource[url] = new EventSource(url, eventSourceInitDict);
    if (onOpen) {
      eventsource[url].onopen = onOpen;
    }
    if (onError) {
      eventsource[url].onerror = onError;
    }
    eventsource[url].onmessage = onMessage;
  }

  if (action.type === REMOVE_EVENT_SOURCE) {
    if (eventsource[action.payload]) {
      eventsource[action.payload].close();
      delete eventsource[action.payload];
    }
  }
};
